import { render, staticRenderFns } from "./LoadRestaurant.vue?vue&type=template&id=291dd94e&"
import script from "./LoadRestaurant.vue?vue&type=script&lang=js&"
export * from "./LoadRestaurant.vue?vue&type=script&lang=js&"
import style0 from "./LoadRestaurant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports